class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  /**
   * On selling plan change.
   * @param {Object} event
   */
  onSellingPlanChange(event) {
    super.onSellingPlanChange(event);

    this.updateProductBar();
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);
    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    this.updateURL();
    this.updateProductBar();
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  /**
   * Update Product Bar.
   *
   * @returns {Void}
   */
  updateProductBar() {
    const productBar = document.querySelector('product-bar');

    if (!productBar) {
      return;
    }

    const sellingPlanField = this.form.elements['selling_plan'];

    productBar.update(
      this.currentVariant,
      this.currentVariantPrice,
      sellingPlanField?.value,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
